import React from 'react'

function UserSearch() {
    return (
        <div>Search</div>
    )
}

export default UserSearch